import React from 'react'
import Button from '@material-ui/core/Button';
import {makeStyles} from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyle = makeStyles(
    (theme) => ({
        overlay: {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255,255,255,1)',
            zIndex:3
        }
    })
)

export default function LoadingButton(props){

    const classes = useStyle();

    const {isLoading,children,...otherProps} = props;

    return (
        <Button {...otherProps}>
            {
                !isLoading && (
                    <span>
                    {children}
                    </span>
                )
            }
            {
                isLoading && (
                    <div className={classes.overlay}>
                        <CircularProgress size={16} disableShrink />
                    </div>
                )
            }
        </Button>
    );

}